<template>
    <form @submit.prevent="sendMessage"
        class="w-full md:w-3/4 lg:w-2/3 xl:w-1/2 mx-auto space-y-4 bg-gray-900/70 backdrop-blur-md p-6 md:p-8 rounded-xl border border-gray-700 shadow-lg transition-all duration-300 hover:border-teal-500">
        <h2 class="text-2xl md:text-3xl font-bold text-teal-400 mb-4 md:mb-6 text-center">{{ $t('letsConnect') }}</h2>

        <div class="space-y-4 md:space-y-6">
            <div>
                <label for="name" class="block text-base font-semibold text-teal-300 mb-2 text-center">{{ $t('yourName')
                    }}</label>
                <input v-model="name" id="name" type="text" :placeholder="$t('namePlaceholder')"
                    class="w-full px-4 py-2 md:py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                    required />
            </div>

            <div>
                <label for="email" class="block text-base font-semibold text-teal-300 mb-2 text-center">{{
                    $t('yourEmail') }}</label>
                <input v-model="email" id="email" type="email" :placeholder="$t('emailPlaceholder')"
                    class="w-full px-4 py-2 md:py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                    required />
            </div>

            <div>
                <label for="message" class="block text-base font-semibold text-teal-300 mb-2 text-center">{{
                    $t('yourMessage') }}</label>
                <textarea v-model="message" id="message" rows="4" :placeholder="$t('messagePlaceholder')"
                    class="w-full px-4 py-2 md:py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                    required></textarea>
            </div>

            <button type="submit"
                class="w-full py-2 md:py-3 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-medium rounded-lg transition-all duration-300 flex items-center justify-center space-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path
                        d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
                </svg>
                <span>{{ $t('send') }}</span>
            </button>
        </div>

        <transition name="fade">
            <div v-if="status" class="mt-3 md:mt-4 p-3 rounded-lg text-center text-sm font-medium" :class="statusClass">
                {{ status }}
            </div>
        </transition>
    </form>
</template>

<script>
import apiClient from "@/api/axios";

export default {
    name: "ContactForm",
    data() {
        return {
            name: "",
            email: "",
            message: "",
            status: "",
        };
    },
    computed: {
        statusClass() {
            return this.status.includes("sent")
                ? "bg-green-900/30 text-green-400 border border-green-800"
                : "bg-red-900/30 text-red-400 border border-red-800";
        },
    },
    methods: {
        async sendMessage() {
            try {
                await apiClient.post("/notifications/email", {
                    to: "adembessam@gmail.com",
                    subject: `Contact form: ${this.name}`,
                    body: `From: ${this.name} <${this.email}>\n\n${this.message.trim()}`,
                });

                this.status = "Message sent! Merci 😊";
                this.name = "";
                this.email = "";
                this.message = "";

                // Clear status after 5 seconds
                setTimeout(() => {
                    this.status = "";
                }, 5000);
            } catch {
                this.status = "Failed to send. Please try again later.";
            }
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

/* Responsive adjustments */
@media (max-width: 640px) {
    form {
        @apply w-full p-4;
    }

    h2 {
        @apply text-xl;
    }
}
</style>